package com.gsb.vyapar.bhagya

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.lifecycle.viewmodel.compose.viewModel
import com.gsb.vyapar.bhagya.interactor.view.MainView
import com.gsb.vyapar.bhagya.interactor.viewmodel.MainViewModel
import org.jetbrains.compose.ui.tooling.preview.Preview

@Composable
@Preview
fun App(deepLink: String? = null) {
    MaterialTheme {
        Surface(
            modifier = Modifier.fillMaxSize(),
            color = MaterialTheme.colors.background
        ) {
            val mainViewModel: MainViewModel = viewModel { MainViewModel(deepLink) }
            val mainUiState by mainViewModel.stateManager.uiStateFlow.collectAsState()
            MainView(mainUiState) { mainViewModel.onTriggerEvent(it) }
        }
    }
}